<template>
  <v-app>
    <v-container fluid grid-list-lg>
        <v-card>          
          <v-app-bar flat>
            <v-icon>security</v-icon>
            <v-toolbar-title class="font-weight-light">&nbsp;Configuración de Seguridad</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{on}">
                <v-btn text icon color="red" v-on="on" @click="setStatusTareaFrecuente(action)">
                  <v-icon v-if="action.esFrecuente">favorite</v-icon>
                  <v-icon v-else>favorite_border</v-icon>
                </v-btn>
              </template>
              <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>  
              <span v-else>Agregar a Tareas Frecuentes</span>  
            </v-tooltip>
          </v-app-bar>
          <v-card-text>
            <v-layout  wrap >               
                <v-flex xs12 sm6 md6 lg6>
                  <v-card>
                    <v-app-bar flat dense :color="$store.state.UiColors.crudToolbarList">
                      <v-icon>list</v-icon>
                      <v-toolbar-title class="font-weight-light">Lista</v-toolbar-title>
                      <v-spacer></v-spacer>                      
                    </v-app-bar>

                    <v-flex right>
                      <v-text-field
                          clearable
                          v-model="search"
                          append-icon="search"
                          label="Buscar por Acción/Rol"
                          single-line
                          hide-details
                      ></v-text-field>
                    </v-flex>

                    <v-data-table 
                      :headers="headers"
                      :items="records"
                      :search="search"
                      :loading="loading"
                      v-model="selectedRow"
                    >
                      <template slot="no-data">
                        <v-alert :value="true" color="grey" icon="warning">
                          No se encontraron datos
                        </v-alert>
                      </template>
                      <template v-slot:item="{ item }">                
                        <tr @click="viewItem(item)">
                            <td class="text-xs-left">{{ item.accionSistemaDescripcion }}</td>
                            <td class="text-xs-left">{{ item.rolUsuarioDescripcion }}</td>
                            <td><v-checkbox :input-value="true" primary hide-details :disabled="true"></v-checkbox></td>
                            <td><v-checkbox :input-value="item.createHabilitado" primary hide-details :disabled="true"></v-checkbox></td>
                            <td><v-checkbox :input-value="item.updateHabilitado" primary hide-details :disabled="true"></v-checkbox></td>
                            <td><v-checkbox :input-value="item.deleteHabilitado" primary hide-details :disabled="true"></v-checkbox></td>

                            <td class="text-xs-left">                
                            <v-icon small class="mr-2" @click="editItem(item)" v-show="canUpdate">edit</v-icon>
                            <v-icon small  @click="deleteItem(item)" v-show="canDelete">delete</v-icon></td>
                        </tr>
                      </template>
                    </v-data-table>
                    
                  </v-card >
                </v-flex>
                
                <v-flex xs12 sm6 md6 lg6>
                  <v-card >
                    <v-app-bar flat dense :color="$store.state.UiColors.crudToolbarDetail">
                      <v-icon>security</v-icon>
                      <v-toolbar-title class="font-weight-light">Detalle</v-toolbar-title>
                      <v-spacer></v-spacer>
                      
                      <v-btn v-if="!editMode" :color="$store.state.UiColors.crudToolbarDetailButtons" fab small top @click="editItem()" v-show="canCreate">
                        <v-icon medium>add_circle_outline</v-icon>
                      </v-btn>
                      
                      <v-btn v-if="model.accionSistemaId != null" 
                        :color="$store.state.UiColors.crudToolbarDetailButtons" fab small top @click="editMode = !editMode" v-show="canUpdate">
                        <v-icon v-if="editMode">cancel</v-icon>
                        <v-icon v-else>edit</v-icon>
                      </v-btn>
                    </v-app-bar>
                    <v-card-text>
                      <v-form :disabled="!editMode">
                        <v-autocomplete v-model="model.accionSistemaId" :items="accionesSistema" 
                            item-text="descripcion" item-value="id" label="Acción" placeholder="Seleccione una acción" 
                            :disabled="!editMode || model.isFromDb==true" :menu-props="{minWidth:'400'}" persistent-hint
                            :hint="accionSeleccionada.descripcion.includes('[AP]')?'Esta es una Acción Puntual (no está en los menúes)':''"></v-autocomplete>

                        <v-autocomplete v-model="model.rolUsuarioId" :items="roles" 
                            item-text="descripcion" item-value="id" label="Rol" placeholder="Seleccione un rol" :disabled="!editMode || model.isFromDb==true" :menu-props="{minWidth:'400'}"></v-autocomplete>

                        <h2>Los usuarios con el rol seleccionado podrán:</h2>

                         <v-switch label="Consultar" v-model="consultaHabilitado" :disabled="true" ></v-switch>
                         <v-switch label="Dar de Alta" v-model="model.createHabilitado" :disabled="!editMode" v-show="accionSeleccionada.esCrud"></v-switch>
                         <v-switch label="Modificar" v-model="model.updateHabilitado" :disabled="!editMode" v-show="accionSeleccionada.esCrud"></v-switch>
                         <v-switch label="Dar de Baja" v-model="model.deleteHabilitado" :disabled="!editMode" v-show="accionSeleccionada.esCrud"></v-switch>

                          <template v-if="$store.state.debugModeOn">
                            Debug Info: <p></p>
                            
                            Model: {{model}}  <p></p>                            
                          </template>
                          <v-divider></v-divider>

                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="success" :disabled="!editMode" @click="saveItem"><v-icon>save</v-icon>Guardar</v-btn>
                          </v-card-actions>

                        </v-form>
                    </v-card-text>
                  </v-card>
                </v-flex>
              
            </v-layout>
          </v-card-text>
        </v-card >
       
    </v-container>
</v-app>
</template>

<script>

import { http } from '@/axios'
import Vue from 'vue'
import {
  mapState,
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'

export default {
  data() {
    return {
      loading: false,
      editMode: false,
      suspend: false,
      search: '', // valor para búsqueda
      headers: [ // definición de columnas
        { text: 'Accion', value: 'accionSistemaDescripcion', align: 'left'},//, width:'300px',fixed:true},
        { text: 'Rol', value: 'rolUsuarioDescripcion'},// width:'150px'},
        { text: 'Consulta', value: 'consulta',sortable: false},//,width:'50px',fixed:true },
        { text: 'Alta', value: 'alta',sortable: false},//width:'50px',fixed:true },
        { text: 'Modificación', value: 'modificacion',sortable: false},//width:'50px',fixed:true },
        { text: 'Baja', value: 'baja',sortable: false},//width:'50px',fixed:true },
        { text: 'Acciones', value: 'name', sortable: false }
      ],        
      records: [], // registros
      selectedRow: [],
      model: {},
      accionesSistema: [],
      roles: [],
      consultaHabilitado:true
    };
  },
  async created() {     
      this.getItems();
      this.loadRoles();
      this.loadAccionesSistema();
  },
  watch: {
    options :{
        handler(){
            Vue.$log.debug(this.options)
        },
        deep: true
    },
    search() {
    },
  },
  computed: {
    ...mapGetters(['checkCanCreate', 'checkCanUpdate', 'checkCanDelete','getActionFromLink']),
    canCreate: function(){
      return this.checkCanCreate(this.$route.path)
    },
    canUpdate: function(){
      return this.checkCanUpdate(this.$route.path)
    },
    canDelete: function(){
      return this.checkCanDelete(this.$route.path)
    },
    action: function(){
      return this.getActionFromLink(this.$route.path)
    },
    accionSeleccionada: function(){
      var accionSeleccionada = this.accionesSistema.find(i=>i.id == this.model.accionSistemaId);
      return accionSeleccionada?accionSeleccionada:{esCrud:false, descripcion: ''};
    }
  },
  methods: {
    ...mapMutations(["alertClear", "alertSuccess", "alertWarning", "alertError"]),
    ...mapActions(['setStatusTareaFrecuente']),
    async getItems() {
      this.loading = true
      this.$validator.reset()

      try {
        var result = await http.get('seguridad');                                    
        
        this.records = result.list;
        this.totalItems = result.totalCount;
      } catch (error) {
        // Error
        this.alertError(error)
      }
      this.loading = false
    },
    async resetState(){      
      this.$validator.reset()
      this.editMode = false;
    },
    async getItem(accionSistemaId, rolUsuarioId) {
      this.loading = true
      this.resetState()

      try {
        var result = await http.get('seguridad/'+accionSistemaId + '/'+rolUsuarioId);

        this.model = result;
      } catch (error) {
        // Error        
        this.alertError(error)
      }
      
      this.loading = false
    },    
    async viewItem(item){
      if(this.suspend) return;

      this.selectedRow.pop()
      this.selectedRow.push(item)

      await this.getItem(item.accionSistemaId,item.rolUsuarioId);
      this.editMode = false;      
    },
    async clearAndReload(){
        // Clear the data inside of the form
        this.model = {}
        this.resetState()

        // Refresco la grilla
        await this.getItems()
    },
    async editItem(item){
      this.suspend = true; // hago esto porque se dispara también el evento click del row (que llama a viewItem)

      if(!item)
        await this.getItem(0,0);
      else
        await this.getItem(item.accionSistemaId,item.rolUsuarioId);
      
      this.editMode = true;
      this.suspend = false;
    },
    async cancelEdit() {
      this.editMode = false;
    },
    async saveItem() {
        await this.$validator.validateAll()
        
        if(this.errors.items.length > 0) return;

        try{
            await http.put('seguridad/updateaccionsistemarol', JSON.stringify( {accionSistemaRol:  this.model}));
            this.alertSuccess('Los cambios han sido guardados.')
            this.clearAndReload();
        } 
        catch(error){
            // Error
            this.alertError(error)
        }               
    },
    async deleteItem(item) {      
      if (confirm('¿Confirma la eliminación de la relación entre la acción ' + item.accionSistemaDescripcion  + 'y el rol ' + item.rolUsuarioDescripcion + '?')) {
        try{
            Vue.$log.debug(item);
            var result = await http.delete('seguridad/deleteaccionsistemarol?accionId='+item.accionSistemaId+'&rolId='+item.rolUsuarioId );
            this.alertSuccess('La relación ha sido eliminada.')
            this.clearAndReload();
        }
        catch(error){
            //Error
            this.alertError(error);
        }
      }
    },
    async loadAccionesSistema(){
      this.loading = true;
      try{
        var result = await http.get('accionessistema/');        
        this.accionesSistema = result.list;
      }
      catch(error){
        // Error
        this.alertError(error)
      }
      this.loading = false;
    },
    async loadRoles(){
      this.loading = true;
      try{
        var result = await http.get('rolesusuario/');        
        this.roles = result.list;
      }
      catch(error){
        // Error
        this.alertError(error)
      }
      this.loading = false;
    }
  }
}
</script>